import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalDeletarPerfilTaxaImposto } from "../redux/slices/perfilTaxaImposto/perfilTaxaImpostoSlice";

export const cadastrarPerfilTaxaImposto = createAsyncThunk("/PerfilTaxaImposto/CadastrarPerfilTaxaImposto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/PerfilTaxaImposto/CadastrarPerfilTaxaImposto/", payload.value);
    toastSucess("Perfil de taxa de imposto cadastrado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarPerfilTaxaImposto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarPerfilTaxaImposto = createAsyncThunk("/PerfilTaxaImposto/BuscarPerfilTaxaImposto", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/PerfilTaxaImposto/BuscarPerfilTaxaImposto", {
      params: { pesquisar: pesquisar },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarTaxaImpostoPerfil = createAsyncThunk("/PerfilTaxaImposto/BuscarTaxaImpostoPerfil", async (idPerfilTaxaImposto: number | null) => {
  try {
    const data = await api.get("/PerfilTaxaImposto/BuscarTaxaImpostoPerfil", {
      params: { idPerfilTaxaImposto: idPerfilTaxaImposto },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarPerfilTaxaImposto = createAsyncThunk("/PerfilTaxaImposto/AtualizarPerfilTaxaImposto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/PerfilTaxaImposto/AtualizarPerfilTaxaImposto", payload.value);
    toastSucess("Perfil de taxa de imposto atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarPerfilTaxaImposto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarPerfilTaxaImposto = createAsyncThunk("/PerfilTaxaImposto/DeletarPerfilTaxaImposto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/PerfilTaxaImposto/DeletarPerfilTaxaImposto", {
      params: { id: payload.value },
    });
    toastSucess("Perfil de taxa de imposto removido com sucesso");
    dispatch(setModalDeletarPerfilTaxaImposto(false));
    dispatch(setLoading(false));

    dispatch(buscarPerfilTaxaImposto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
